import { useEffect } from 'react';

// Store
import useHasher from '@src/stores/hasher';

export const ReactHash = ({ name, hash }) => {
  const setHash = useHasher((state) => state.setHash);

  useEffect(() => {
    if (!name || !hash) return;

    setHash(name, hash);
  }, []);

  return null;
};
